import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  FormControl,
  Select,
  MenuItem,
  Box,
  Typography,
  CircularProgress,
  Alert,
  Button,
} from '@mui/material';
import { Visibility } from '@mui/icons-material';
import { Link } from 'react-router-dom';
import { useAdminPlaces } from '../hooks/useAdminPlaces';

const PlaceManagement = () => {
  const {
    places,
    isLoading,
    isError,
    error,
    updateStatus,
    updateVip,
    isUpdatingStatus,
    isUpdatingVip,
  } = useAdminPlaces();

  const handleStatusChange = (status: string, placeId: string) => {
    updateStatus(placeId, status);
  };

  const handleVipChange = (vip: boolean, placeId: string) => {
    updateVip(placeId, vip);
  };

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (isError) {
    return (
      <Box sx={{ px: 5, pt: 2 }}>
        <Alert severity="error">Error loading places: {error?.message || 'Unknown error'}</Alert>
      </Box>
    );
  }

  return (
    <Box sx={{ px: 5, pt: 2 }}>
      <Typography variant="h4">Place Management</Typography>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Place Name</TableCell>
              <TableCell>Created By</TableCell>
              <TableCell>Created At</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Vip</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {places.map((place) => (
              <TableRow key={place._id}>
                <TableCell>{place.name}</TableCell>
                <TableCell>{place.createdBy}</TableCell>
                <TableCell>
                  {new Date(place.createdDate).toLocaleString()}
                </TableCell>
                <TableCell>
                  <FormControl variant="outlined">
                    <Select
                      value={place.status}
                      onChange={(e) =>
                        handleStatusChange(e.target.value, place._id)
                      }
                      disabled={isUpdatingStatus}
                    >
                      <MenuItem value="approved">Approved</MenuItem>
                      <MenuItem value="pending">Pending</MenuItem>
                      <MenuItem value="rejected">Rejected</MenuItem>
                    </Select>
                  </FormControl>
                </TableCell>
                <TableCell>
                  {place.status === 'approved' ? (
                    <FormControl variant="outlined">
                      <Select
                        value={String(place.vip || false)}
                        onChange={(e) =>
                          handleVipChange(e.target.value === 'true', place._id)
                        }
                        disabled={isUpdatingVip}
                      >
                        <MenuItem value="true">True</MenuItem>
                        <MenuItem value="false">False</MenuItem>
                      </Select>
                    </FormControl>
                  ) : (
                    <Typography variant="body2" color="text.secondary">
                      Place is not approved
                    </Typography>
                  )}
                </TableCell>
                <TableCell>
                  <Button
                    component={Link}
                    to={`/places/${place._id}`}
                    variant="outlined"
                    startIcon={<Visibility />}
                    size="small"
                  >
                    View
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default PlaceManagement;
